<template>
  <div class="flex flex-col justify-center align-center">
    <div class="flex justify-center">
      <img alt="Vue logo" src="../../assets/logo.png" />
    </div>
    <HelloWorld msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
import HelloWorld from "@/components/HelloWorld";

export default {
  name: "Home",
  components: {
    HelloWorld
  }
};
</script>
